// src/hooks/useAppReset.ts
import { useCallback } from 'react';
import { persistor, RESET_STORE } from 'store';
import { useAppDispatch } from 'store/hook';

export const useResetReduxAndWebStorage = () => {
  const dispatch = useAppDispatch();
  const resetApp = useCallback(async () => {
    try {
      // pause persistor to prevent concurrent writes
      persistor.pause();

      // clear all session storage
      sessionStorage.clear();

      // clear non-Auth0 localStorage items (preserve Auth0 auth session to avoid re-authentication loops)
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (
          key &&
          !key.startsWith('@@auth0spajs@@') &&
          !key.startsWith('auth0') &&
          !key.startsWith('_auth0')
        ) {
          keysToRemove.push(key);
        }
      }
      for (const key of keysToRemove) {
        localStorage.removeItem(key);
      }

      // clear redux-persist storage
      await persistor.purge();

      // reset in-memory Redux store
      dispatch({ type: RESET_STORE });

      // resume persistor
      persistor.persist();

      console.info('All state cleared and store reinitialized.');
    } catch (error) {
      console.error('Failed to reset app state', error);
    }
  }, [dispatch]);

  return resetApp;
};
